<template>
  <ul class="breadcrumbs" v-if="links">
    <li>
      <router-link to="/">
        <i class="mdi mdi-home"></i>
      </router-link>
    </li>
    <li v-for="(item, index) in links" :key="index">
      <template v-if="item.link">
        <router-link :to="item.link">{{ item.label }}</router-link>
      </template>
      <template v-else>
        <span>{{ item.label }}</span>
      </template>
    </li>
  </ul>
</template>
<script>
const name = 'Breadcrumbs'

import SvgIcon from '@/components/SvgIcon'

const computed = {
  links() {
    const inst = this

    if (inst.$route.name == 'equipCategory') {
      let category = inst.$store.state.equipment.categories.find(element => {
        return element.slug == inst.$route.params.category
      })

      return [{
        link: '/equipment',
        label: 'Оборудование'
      }, {
        label: category.name
      }]

    } else if (inst.$route.name == 'equipItem') {
      let category = inst.$store.state.equipment.categories.find(element => {
        return element.slug == inst.$route.params.category
      })

      let item = inst.$store.state.equipment.equipment.find(element => {
        return element.slug == inst.$route.params.slug
      })

      return [{
        link: '/equipment',
        label: 'Оборудование'
      }, {
        link: `/equipment/${inst.$route.params.category}`,
        label: category.name
      }, {
        label: item.title
      }]
    } else {
      return null
    }

  }
}

export default {
  name,
  computed,
  components: {
    SvgIcon
  }
}

</script>
